import { createReducer } from 'typesafe-actions';
import { 
  loadShips,
  loadPorts,
  loadShipsRequest
} from './shipLocations.actions';
import { ShipData, CMSShipData, PortData } from '../../services/types';
import shipSpecs from '../../assets/data/shipSpecs.json';
export interface ShipLocationsState {
  shipLocations: ShipData[];
  isShipLocationsLoading: boolean;
  ports: PortData[];
}

export const shipLocationsState: ShipLocationsState = {
  shipLocations: [],
  isShipLocationsLoading: false,
  ports: []
};



export default createReducer<ShipLocationsState>(shipLocationsState)
  .handleAction(loadShipsRequest, state => ({
    ...state,
    isShipLocationsLoading: true
  }))
  .handleAction(
    loadShips.success,
    (state, action) => {
      const seabournShips: ShipData[] = action.payload
        .filter((ship) => ship.CompanyCode === 'S' && ship.NauticalInfo.Position)
        .map((ship: CMSShipData)=>{
          let reducedShip: any = ship;
          const specs: any = shipSpecs;
          const position = ship.NauticalInfo.Position;
          reducedShip.latitude = +parseFloat(position.Latitude.Value).toFixed(2);
          reducedShip.longitude = +parseFloat(position.Longitude.Value).toFixed(2);
          delete reducedShip.NauticalInfo;
          reducedShip.temperature = ship.MeteoInfo.Temperature?.Value;
          delete reducedShip.MeteoInfo;
          reducedShip.ports = ship.CruiseInfo ? ship.CruiseInfo.Ports : [];
          reducedShip = {...reducedShip, ...specs[ship.FidelioCode] };

          return reducedShip;
        });

      return {
        ...state,
        shipLocations: seabournShips
      };
    }
  )
  .handleAction(
    loadPorts.success,
    (state, action) => {
      const ports = action.payload.filter((port) => port.data.lat && port.data.long).map((port)=>{
        return {
          ...port,
          images: port.data.images.map((image) => ({...image.image})),
          lat: parseFloat(port.data.lat),
          long: parseFloat(port.data.long),
        };
      });
      return {
        ...state,
        ports: ports
      };
    }
  );
  
